import axios from 'axios';
import mailConfig from '../config/mail';
import ExamAction from '../actions/ExamAction';
import UserAction from '../actions/UserAction';
import ReportAction from '../actions/ReportAction';
import SlackWebHook from "../services/Slack";
import Validation from "../services/Validation";

const mailer = {

    // request api to send mail
    // @ author: Arijit Deb Roy
    // @ params: mailType, to, cc[], bcc[], subject, attachment(0/1) data{}

    sendMail(to, mailType, cc, bcc, subject, attachmentStatus = false, data) {
        const sendData = {
            "mailType" : mailType,
            "to" : to,
            "cc" : cc,
            "bcc" : bcc,
            "subject" : subject,
            "attachment": attachmentStatus,
            "data": data
        }
        return axios.post(`${process.env.NEXT_PUBLIC_MAIL_URL}/mail?_format=json`, sendData)
            .then(res => res.data)
            .catch(error => error);
    },

    registration(payload) {
        try {
            if(mailConfig["newStudentLinkToAgent-mail"] && payload.referralDetails) {
                let data = {
                    "emailTitle": "Referral Linked",
                    "agentName": payload.referralDetails.firstName,
                    "studentName": payload.firstName
                };
                this.sendMail(payload.referralDetails.email, 'newStudentLinkToAgent-mail', [], [], `${payload.firstName} is your referral`, false, data)
            }
            if(mailConfig["afterSignUp-mail"]) {
                let data = {
                    "emailTitle": `Welcome to ${process.env.NEXT_PUBLIC_APP_NAME}`,
                    "name": payload.firstName,
                    "actionUrl": `${process.env.NEXT_PUBLIC_APP_URI}/dashboard`
                };
                this.sendMail(payload.email, 'afterSignUp-mail', [], [], `Welcome to ${process.env.NEXT_PUBLIC_APP_NAME}`, false, data)
            }
        }catch(err) {
            SlackWebHook.sendSlackMessage('Mail','registration',`${err.message}`)
        }
    },

    /**
     * @author Susanta Chakraborty
     * @param {input} input object with userExamId examtype studentId and CourseId
     * @returns url<string>
     */
    partnerReportLink(input) {
        // report/detail?cql=courseId_=MQ==$studentId_=MTA1NzQ=$userExamId_=MTgwNQ==$examType_=
        return `report/detail?cql=courseId_=${input.courseId}$studentId_=${input.studentId}$userExamId_=${input.userExamId}$examType_=${input.examType}`;
    },

    fullMock(payload) {
        try {
            ExamAction.mockMailDetails(payload.userExamId).then((res) => {
                let responseMain = res.data.mockMailDetails;
                if(responseMain.code === '200' && responseMain.status === 'success'){
                    if(mailConfig["mockTestResult-mail"]) {
                        let data = {
                            "studentName": payload.firstName,
                            "mockScore":  Math.round(responseMain.data.mockScore),
                            "previousMockScore": responseMain.data.previousMockScore === null ? null : Math.round(responseMain.data.previousMockScore),
                            "courseName": payload.courseName,
                            "actionUrl": `${process.env.NEXT_PUBLIC_APP_URI}${payload.uri}`,
                            "unsubscribeUrl": null
                        };
                        this.sendMail(payload.email, 'mockTestResult-mail', [], [], `"Mock Test Report - ${payload.title}`, false, data)
                    }
                    if(mailConfig["mockCompletionReport-mail-to-teachers"]) {
                        UserAction.teacherList(payload.studentId, payload.courseId).then((res) => {
                            let response = res.data.fetchTeacherListByStudentId.data.teacherList;
                            response.forEach(val => {
                                let data = {
                                    "emailTitle": payload.firstName + "'s Mock Report",
                                    "recipientName": val.firstName,
                                    "studentName": payload.firstName + " has",
                                    "mockName": payload.title,
                                    "courseName": payload.courseName,
                                    "mockScore": Math.round(responseMain.data.mockScore),
                                    "previousMockScore": responseMain.data.previousMockScore === null ? null : Math.round(responseMain.data.previousMockScore),
                                    "mockTime": Validation.secondsToHms(responseMain.data.mockTime, ":"),
                                    "previousMockTime": responseMain.data.previousMockTime === null ? null : Validation.secondsToHms(responseMain.data.previousMockTime, ":"),
                                    "updatedPredictiveScore": responseMain.data.updatedPredictiveScore === null ? null : responseMain.data.updatedPredictiveScore,
                                    "actionUrl": `${process.env.NEXT_PUBLIC_PARTNER_URI}${this.partnerReportLink(payload.input)}`,
                                };
                                this.sendMail(val.email, 'mockCompletionReport-mail', [], [], `${payload.firstName} has completed a mock test \u23F0"`, false, data)
                            });
                        }).catch((err) => {
                            SlackWebHook.sendSlackMessage('Mail','teacherList',`${err.message}`);
                        });
                    }
                    if(mailConfig["mockCompletionReport-mail-to-parents"]) {
                        UserAction.parentList(payload.studentId).then((res) => {
                            let response = res.data.fetchParentListByStudentId.data.parentList;
                            response.forEach(val => {
                                let data = {
                                    "emailTitle": payload.firstName + "'s Mock Report",
                                    "recipientName": val.firstName,
                                    "studentName": payload.firstName + " has",
                                    "mockName": payload.title,
                                    "courseName": payload.courseName,
                                    "mockScore": Math.round(responseMain.data.mockScore),
                                    "previousMockScore": responseMain.data.previousMockScore === null ? null : Math.round(responseMain.data.previousMockScore),
                                    "mockTime": Validation.secondsToHms(responseMain.data.mockTime, ":"),
                                    "previousMockTime": responseMain.data.previousMockTime === null ? null : Validation.secondsToHms(responseMain.data.previousMockTime, ":"),
                                    "updatedPredictiveScore": responseMain.data.updatedPredictiveScore === null ? null : responseMain.data.updatedPredictiveScore,
                                    "actionUrl": `${process.env.NEXT_PUBLIC_PARTNER_URI}${this.partnerReportLink(payload.input)}`,
                                };
                                this.sendMail(val.email, 'mockCompletionReport-mail', [], [], `${payload.firstName} has completed a mock test \u23F0"`, false, data)
                            });
                        }).catch((err) => {
                            SlackWebHook.sendSlackMessage('Mail','parentList',`${err.message}`);
                        });
                    }
                }else {
                    SlackWebHook.sendSlackMessage('Mail','mockMailDetails', 'else case');
                }
            }).catch((err) => {
                SlackWebHook.sendSlackMessage('Mail','mockMailDetails',`${err.message}`);
            });
        }catch(err) {
            SlackWebHook.sendSlackMessage('Mail','fullMock',`${err.message}`);
        }
    },

    otherExam(payload) {
        try {
            if(mailConfig["diagnosticTestScore-mail"] && payload.examType === "diagnostic") {
                const inputObj = {
                    userExamId: parseInt(payload.userExamId),
                    examType: "diagnostic"
                }
                ReportAction.reportStats(inputObj).then((res) => {
                    const response = res.data.fetchUserReportStats;
                    if (response.code == "200" && response.status == "success") {
                        let data = {
                            "studentName": payload.firstName,
                            "diagnosticScore": Math.round(response.data.reports[0].score) + '%',
                            "correctAnswers": response.data.reports[0].totalCorrect,
                            "incorrectAnswers": response.data.reports[0].questionAttempt - response.data.reports[0].totalCorrect,
                            "courseName": payload.courseName,
                            "actionUrl": `${process.env.NEXT_PUBLIC_APP_URI}${payload.uri}`,
                        };
                        this.sendMail(payload.email, 'diagnosticTestScore-mail', [], [], `${payload.courseName} Diagnostic Test Completed`, false, data)
                    } else {
                        SlackWebHook.sendSlackMessage('Mail', 'reportStats', `else case`);
                    }
                }).catch((err) => {
                    SlackWebHook.sendSlackMessage('Mail', 'reportStats', `${err.message}`);
                });
            }
            if(mailConfig["weeklyQuizCompleted-mail"] && payload.examType !== "diagnostic") {
                let data = {
                    "studentName": payload.firstName,
                    "emailTitle": "Weekly Quiz Completed",
                    "actionUrl": `${process.env.NEXT_PUBLIC_APP_URI}${payload.uri}`,
                    "unsubscribeUrl": null
                };
                this.sendMail(payload.email, 'weeklyQuizCompleted-mail', [], [], 'Weekly Quiz Completed', false, data)
            }
            if(mailConfig["youVsRest-mail"] && payload.examType !== "diagnostic" && payload.weeklyAttempt === 1) {
                let data = {
                    "courseName": payload.courseName,
                    "actionUrl": `${process.env.NEXT_PUBLIC_APP_URI}${payload.uri}`,
                    "unsubscribeUrl": null
                };
                this.sendMail(payload.email, 'youVsRest-mail', [], [], `${process.env.NEXT_PUBLIC_APP_NAME} helps you to compare yourself with others`, false, data)
            }
        }catch(err) {
            SlackWebHook.sendSlackMessage('Mail','otherExam',`${err.message}`)
        }
    },

    paymentSuccess(payload) {
        try {
            if(mailConfig["newPaidStudentToAgent-mail"]) {
                UserAction.agentDetails({userId: payload.studentId}).then((res) => {
                    let response = res.data.agentDetails;
                    if(response.code === '200'){
                        if(response.data) {
                            let data = {
                                "emailTitle": payload.firstName +" Subscribed",
                                "agentName": response.data.firstName,
                                "studentName": payload.firstName,
                                "courseName": payload.courseName,
                                "courseDuration": payload.duration
                            };
                            this.sendMail(response.data.email, 'newPaidStudentToAgent-mail', [], [], `${payload.firstName} has subscribed`, false, data)
                        }
                    }else {
                        SlackWebHook.sendSlackMessage('Mail', 'agentDetails', `else case`);
                    }
                }).catch( (err) => {
                    SlackWebHook.sendSlackMessage('Mail', 'agentDetails', `${err.message}`);
                });
            }
            if(mailConfig["paymentSuccess-mail"]) {
                let data = {
                    "emailTitle": "Payment Successful",
                    "userName": `${payload.firstName} ${payload.lastName}`,
                    "amount": payload.amount,
                    "productName": `${payload.courseName} - ${payload.duration}`
                };
                this.sendMail(payload.email, 'paymentSuccessEmail', [], process.env.NEXT_PUBLIC_PAYMENT_BCC_EMAILS.split(','), 'Payment Success', false, data)
            }
        }catch(err) {
            SlackWebHook.sendSlackMessage('Mail','paymentSuccess',`${err.message}`)
        }
    },

    paymentFailure(payload) {
        try {
            if(mailConfig["paymentFailure-mail"]) {
                let data = {
                    "emailTitle": "Payment Failed",
                    "userName": `${payload.firstName} ${payload.lastName}`,
                    "amount": payload.amount,
                    "productName": `${payload.courseName} - ${payload.duration}`
                };
                this.sendMail(payload.email, 'paymentFailureEmail', [], [], 'Payment Failed', false, data)
            }
        }catch(err) {
            SlackWebHook.sendSlackMessage('Mail','paymentFailure',`${err.message}`)
        }
    },
}

export default mailer;
